import './index.less';
import React from 'react';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class Modal extends React.Component {
	constructor(props) {
		super(props);

		this.closebutton = props.colour === 'blue' ? 'close-button' : 'close-button-dark';

		this.state = {
			animate: false
		};
	}

	componentDidMount() {
		setTimeout(
			() =>
				this.setState({
					animate: true
				}),
			150
		);
	}

	handleClose() {
		this.setState({
			animate: false
		});

		setTimeout(() => {
			this.props.onClose();
		}, 150);
	}

	render() {
		const { colour, overflow = 'auto' } = this.props;
		const { animate } = this.state;

		return (
			<React.Fragment>
				<div
					className={`Modal__overlay ${animate ? 'Modal__overlay--show' : ''}`}
					onClick={() => this.handleClose()}
				/>
				<div
					className={`Modal Modal--${colour} Modal--overflow-${overflow} ${
						animate ? 'Modal--open' : ''
					}`}
				>
					<div className={`Modal__content ${animate ? 'Modal__content--show' : ''}`}>
						{this.props.children}
					</div>
					<div className={`Modal__close`}>
						<ReactCKImage
							name={this.closebutton}
							handleClick={() => this.handleClose()}
							options={{ width: '2rem', height: '2rem' }}
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

Modal.propTypes = {
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func.isRequired,
	colour: PropTypes.string.isRequired,
	overflow: PropTypes.string
};
